import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import MembersSettingService from "Lib/API/MemberSetting/MemeberSetting";
import { ReactComponent as CopyIconGray } from "assets/icons/CopyIconGray.svg";
import { ReactComponent as MergeIcon } from "assets/icons/MergeAccountIcon.svg";
import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import axios from "axios";
import { CopyToClipboard } from "react-copy-to-clipboard";

import {
  InputField,
  LabelField,
  MyCheckbox,
  SelectField,
  Text,
} from "components";
import FindMyCity from "components/FindMyCity";
import InfoTooltip from "components/InfoTooltip";
import { PhonePicker } from "components/PhonePicker";
import { useFormik } from "formik";
import { useSearch } from "hook";
import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import Select, { components } from "react-select";
import { colors } from "theme";
import { AccountInfoSchema } from "../../ValidationSchema";
import "./style.scss";

import FinanceService from "Lib/API/Finance";
import MemberService from "Lib/API/Member/index";
import { ReactComponent as MinusDelete } from "assets/icons/PendingIcon.svg";
import NewDialog from "components/NewDialog/Dialog";
import Button from "components/button/Button";
import {
  getDateFormat,
  getDateFormatForDatePicket,
  maskDate,
} from "helper/dateFormat";
import {
  postalCodeFormat,
  postalCodeLabel,
  stateLabel,
} from "helper/postalCodeFormat";
import DatePicker from "react-datepicker";
import { isValidPhoneNumber } from "react-phone-number-input";
import { BeatLoader } from "react-spinners";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import AlertDialog from "../../../components/Dialog";
import Loader from "../../../components/loader/Loader";
import { MergeAccountsDetails } from "./MergeAccounts/MergeAccountsDetails";
import {
  Buttons,
  CheckBox,
  CheckBoxesContainer,
  ContentWrapper,
  Label,
  Wrapper,
} from "./Theme";

const styles = {
  circleButtonBody: {
    background: "#FFFFFF",
    borderRadius: "50%",
    width: 20,
    height: 20,
    right: 0,
    top: 3,
    cursor: "pointer",
  },
  textIconButton: {
    color: colors.primaryColor,
    fontSize: 16,
  },
};

const AccountInfo = ({ account, setRefresh, refresh }) => {
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const [accountBillingTypes, setAccountBillingTypes] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingArchive, setLoadingArchive] = useState(false);
  const [catagoryTypes, setCatagoryTypes] = useState([]);
  const [search, setSearch] = useState("");
  const { searchAction } = useSearch({ action: setSearch });
  const [selectfieldColor, setSelectfieldColor] = useState(true);
  const [addressInfo, setAddressInfo] = useState([]);
  const [indexValue, setIndexValue] = useState("");
  const [indexBillingValue, setIndexBillingValue] = useState("");
  const [indexApplyAllContactValue, setIndexApplyAllContactValue] =
    useState(null);
  const [booleanValue, setBooleanValue] = useState(false);
  const [joinDate, setJoinDate] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMergePopUp, setIsOpenMergePopUp] = useState(false);
  const [loadingMerge, setLoadingMerge] = useState(false);
  const [openDialog, setOpen] = React.useState(false);
  const [deletedId, SetDeletedId] = useState(null);
  const [addressValue, setAddressValue] = useState(false);
  const [message, setMessage] = useState("");
  const [value, setValue] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const [openDisableMemberUserModal, setOpenDisableMemberUserModal] =
    useState(false);

  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();

  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(
    dateFormat || "mm/dd/yyyy"
  );

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };

  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };

  const options =
    accountBillingTypes &&
    accountBillingTypes.map((item) => {
      return {
        label: item?.title,
        value: item?._id,
      };
    });
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
      height: 48,
    }),
  };

  const enableLoading = (value) => {
    setLoading(value);
  };

  const initialValues = {
    account: {},
    archived: account?.archived,
    hideDirectory: account?.hideDirectory,
    hideEmail: account?.hideEmail,
    hideMobile: account?.hideMobile,
    hideHomeNumber: account?.hideHomeNumber,
    hideAddress: account?.hideAddress,
    location: account?.main_contact?.location,
    family_name: account?.admin_name,
    account_id: account?.account_id,
    family_members: account?.family_members?.length,
    old_account_id: account?.old_account_id,
    family_admin_name: account?.family_name
      ? account?.family_name
      : `${account?.main_contact?.first_name} ${account?.main_contact?.last_name}`,
    family_admin_contact: account?.admin_contact
      ? account?.admin_contact
      : account?.main_contact?.phone_number
      ? account?.main_contact?.phone_number
      : "",
    account_type:
      account?.payment?.account_type === "member"
        ? "Member"
        : account?.payment?.account_type === "organization"
        ? "organization"
        : "Not a Member",

    account_sub_type: {
      id: account?.payment?.account_sub_type?.id,
      title: account?.payment?.account_sub_type?.title,
    },
    billing_type: {
      id: account?.payment?.billing_type?.id,
      title: account?.payment?.billing_type?.title,
    },

    product_id: {
      value: account?.payment?.product_id?._id,
      label: account?.payment?.product_id?.prod_name,
    },

    addressInfo: account?.addresses ?? [
      {
        neighborhood: "",
        addressLine2: "",
        country: "",
        active: false,
        billing: true,
        location: {},
        city: account?.city,
        state: account?.state,
        zip_code:
          account?.zip_code == "0"
            ? "0000"
            : account?.zip_code != "0"
            ? account?.zip_code
            : account?.main_contact?.zip_code,
      },
    ],
    join_date: account?.join_date
      ? account?.join_date
      : // : account?.createdAt
        // ? account?.createdAt
        "",
    resign_date: account?.resign_date,
    mailLabelName: account?.mailLabelName,
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: AccountInfoSchema,
  });
  const handleArchiveOnChange = () => {
    formik.setFieldValue("archived", !formik.values?.archived);
    setMessage(
      formik.values?.archived
        ? "Do you want to Unarchive this account?"
        : "Do you want to archive this account?"
    );
    setIsOpen(true);
  };
  const handleConfirmArchiveAccount = async () => {
    const token = await getAccessTokenSilently();
    setLoadingArchive(true);
    await MemberService.archiveAccount(
      {
        accId: account?._id,
        archived: formik.values?.archived,
      },
      token
    )
      .then((res) => {
        enableLoading(false);
        setIsOpen(false);
        setLoadingArchive(false);
        onSubmit();
      })
      .catch((err) => {
        enableLoading(false);
        setLoadingArchive(false);

        toastr.error(
          "error",
          err?.data?.message || "Account Info are not updated"
        );
      });
  };

  const openDisableMemberUserHandler = () => {
    setOpenDisableMemberUserModal(true);
  };

  const validateSubmit = async () => {
    onSubmit();
  };

  const onSubmit = async (applyAddressToContacts) => {
    if (Object.keys(formik.errors).length > 0) {
      return toastr.info("Validation", "Please fill all mandatory fields");
    }
    const data = formik?.values?.addressInfo.map((object) => {
      return object.active === true;
    });
    const formattedAddress = formik?.values?.addressInfo.map((object) => {
      return object?.location?.formattedAddress;
    });
    const counts = {};
    const sampleArray = data;
    sampleArray.forEach(function (x) {
      counts[x] = (counts[x] || 0) + 1;
    });

    const bilingData = formik?.values?.addressInfo.map((object) => {
      return object.billing === true;
    });

    const billingCounts = {};
    const bilingSampleArray = bilingData;
    bilingSampleArray.forEach(function (x) {
      billingCounts[x] = (billingCounts[x] || 0) + 1;
    });

    if (counts?.true > 1) {
      toastr.error("Validation", "Only one address should be Active");
    } else if (billingCounts?.true > 1) {
      toastr.error("Validation", "You can mark only one address as billing");
    } else if (
      formattedAddress.length > 0 &&
      formattedAddress?.[0] != undefined &&
      !counts?.true
    ) {
      toastr.error("Validation", "Address should be active");
    } else if (
      formattedAddress.length > 0 &&
      formattedAddress?.[0] != undefined &&
      !billingCounts?.true
    ) {
      toastr.error("Validation", "Billing should be active");
    } else {
      if (
        account?.payment?.account_type === "member" &&
        formik.values.account_type !== "Member"
      ) {
        return openDisableMemberUserHandler();
      }
      updateAccountDetailsHandler();
    }
  };

  const updateAccountDetailsHandler = async (disableMemberPortal = false) => {
    const validContactPhone = isValidPhoneNumber(
      formik?.values?.family_admin_contact || ""
    );
    if (formik?.values?.family_admin_contact && !validContactPhone) {
      toastr.info("Validation", "Invalid Family Admin Contact");
    }

    const validZipCode = formik?.values?.addressInfo?.every((address) =>
      postalCodeFormat(address?.zip_code)
    );

    if (!validZipCode) {
      toastr.info("Validation", `Invalid ${postalCodeLabel()}`);
    }

    enableLoading(true);
    const token = await getAccessTokenSilently();
    const input =
      formik.values?.family_admin_contact === ""
        ? {
            accountID: account?._id,
            payment: {
              account_type:
                formik.values.account_type === "Member"
                  ? "member"
                  : formik.values.account_type === "Not a Member"
                  ? "non-member"
                  : "organization",
              account_sub_type: formik.values?.account_sub_type?.id
                ? {
                    id: formik.values?.account_sub_type?.id,
                    title: formik.values?.account_sub_type?.title,
                  }
                : undefined,
              billing_type: formik.values?.billing_type?.id
                ? {
                    id: formik.values?.billing_type?.id,
                    title: formik.values?.billing_type?.title,
                  }
                : undefined,
            },
            addresses: formik?.values?.addressInfo,
            //  [
            //   {
            //     ...formik?.values?.addressInfo?.[0],
            //     zip_code: validZipCode,
            //   },
            // ],
            family_name: formik.values?.family_admin_name,
            admin_name: formik.values?.family_name,
            old_account_id: formik.values?.old_account_id,
            resign_date: formik.values?.resign_date ?? null,
            join_date: formik.values?.join_date ?? null,
            // applyAddressToContacts: applyAddressToContacts ?? undefined,
            hideDirectory: formik.values?.hideDirectory,
            hideEmail: formik.values?.hideEmail,
            hideMobile: formik.values?.hideMobile,
            hideHomeNumber: formik.values?.hideHomeNumber,
            hideAddress: formik.values?.hideAddress,
            mailLabelName: formik.values?.mailLabelName,
            disableMemberPortal,
          }
        : {
            accountID: account?._id,
            addresses: formik?.values?.addressInfo,
            payment: {
              account_type:
                formik.values.account_type === "Member"
                  ? "member"
                  : formik.values.account_type === "Not a Member"
                  ? "non-member"
                  : "organization",
              account_sub_type: formik.values?.account_sub_type?.id
                ? {
                    id: formik.values?.account_sub_type?.id,
                    title: formik.values?.account_sub_type?.title,
                  }
                : undefined,
              billing_type: formik.values?.billing_type?.id
                ? {
                    id: formik.values?.billing_type?.id,
                    title: formik.values?.billing_type?.title,
                  }
                : undefined,
            },

            admin_contact: formik.values?.family_admin_contact
              ? formik.values?.family_admin_contact
              : "",
            admin_name: formik.values?.family_name,
            family_name: formik.values?.family_admin_name,
            old_account_id: formik.values?.old_account_id,
            resign_date: formik.values?.resign_date ?? null,
            join_date: formik.values?.join_date ?? null,
            // applyAddressToContacts: applyAddressToContacts ?? undefined,
            hideDirectory: formik.values?.hideDirectory,
            hideEmail: formik.values?.hideEmail,
            hideMobile: formik.values?.hideMobile,
            hideHomeNumber: formik.values?.hideHomeNumber,
            hideAddress: formik.values?.hideAddress,
            mailLabelName: formik.values?.mailLabelName,
            disableMemberPortal,
          };

    await AuthService.updateAccountDetails(input, token)
      .then((res) => {
        // history.push("/members");
        enableLoading(false);
        toastr.success("Success", "Account Info updated successfully");
        setRefresh(!refresh);
        if (disableMemberPortal) setOpenDisableMemberUserModal(false);
      })
      .catch((err) => {
        enableLoading(false);
        toastr.error(
          "error",
          err?.data?.message || "Account Info are not updated"
        );
      });
  };

  // Get Account Billing Types List
  const fetchAccountBillingTypes = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getAccountBillingTypes(token).then((res) => {
      setAccountBillingTypes(res?.result);

      // setAccountBillingTypes(res?.result?.map((item) => item.title));
    });
  };

  const getTypes = async () => {
    const token = await getAccessTokenSilently();
    const type = formik.values?.account_type;
    await MembersSettingService.getCatagoryListByType(
      type === "Member"
        ? "member"
        : type === "Not a Member"
        ? "not_member"
        : type === "Organization" || type === "organization"
        ? "organization"
        : "",
      token
    )
      .then((res) => {
        setCatagoryTypes(res?.result);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  const [placeID, setPlaceID] = useState("");

  React.useEffect(() => {
    fetchAccountBillingTypes();
  }, [formik.values?.billing_type]);

  React.useEffect(() => {
    getTypes();
  }, [formik.values?.account_type]);

  useEffect(() => {
    if (account?.addresses?.length > 0) {
      account.addresses.map((item, idx) => {
        if (item.active === true) {
          setIndexValue(idx);
        }
        if (item.billing === true) {
          setIndexBillingValue(idx);
        }
      });
    }
  }, [account]);
  useEffect(() => {
    if (formik?.values?.addressInfo.length === 1) {
      formik.values.addressInfo.forEach((item, index) => {
        formik.setFieldValue(`addressInfo.${index}.active`, true);
        formik.setFieldValue(`addressInfo.${index}.billing`, true);
      });
    } else {
      formik.values.addressInfo.forEach((item, index) => {
        if (index === indexValue) {
          formik.setFieldValue(`addressInfo.${index}.active`, true);
        } else {
          formik.setFieldValue(`addressInfo.${index}.active`, false);
        }

        if (index === indexBillingValue) {
          formik.setFieldValue(`addressInfo.${index}.billing`, true);
        } else {
          formik.setFieldValue(`addressInfo.${index}.billing`, false);
        }
      });
    }
  }, [formik.values.addressInfo]);

  const handleApplyAddressToContactsChange = (idx) => {
    formik.values.addressInfo.forEach((item, index) => {
      if (index === idx) {
        formik.setFieldValue(
          `addressInfo.${index}.applyAddressToContacts`,
          true
        );
      } else {
        formik.setFieldValue(
          `addressInfo.${index}.applyAddressToContacts`,
          false
        );
      }
    });
  };

  const options2 =
    catagoryTypes &&
    catagoryTypes.map((item) => {
      return {
        label: item?.title,
        value: item?._id,
      };
    });
  const addressHandleChange = async (address, idx) => {
    formik.setFieldValue(`addressInfo.${idx}.location`, {
      formattedAddress: (address?.label).split(",")[0],
      place_id: address.value?.place_id || null,
    });
    setPlaceID(address?.value?.place_id);
    if (!address?.value?.place_id) {
      formik.setFieldValue(`addressInfo.${idx}.zip_code`, "");
      formik.setFieldValue(`addressInfo.${idx}.neighborhood`, "");
      formik.setFieldValue(`addressInfo.${idx}.country`, "");
      formik.setFieldValue(`addressInfo.${idx}.state`, "");
      formik.setFieldValue(`addressInfo.${idx}.city`, "");
    } else {
      const result = await axios(
        `https://maps.googleapis.com/maps/api/geocode/json?place_id=${address?.value?.place_id}&key=AIzaSyCAt0TjvU_m8ufUMYn2EXi9mteHSOUB7uA`
      );

      let zip_code = result.data.results[0].address_components?.filter(
        (item) => item.types[0] == "postal_code"
      );
      formik.setFieldValue(
        `addressInfo.${idx}.zip_code`,
        zip_code?.[0]?.short_name
      );
      let countryData = result.data.results[0].address_components?.filter(
        (item) => item.types[0] == "country"
      );
      formik.setFieldValue(
        `addressInfo.${idx}.country`,
        countryData[0].short_name
      );
      if (address?.value?.terms.length === 3) {
        formik.setFieldValue(
          `addressInfo.${idx}.state`,
          address?.value?.terms[2]?.value
        );
        formik.setFieldValue(
          `addressInfo.${idx}.city`,
          address?.value?.terms[1]?.value
        );
      } else {
        formik.setFieldValue(
          `addressInfo.${idx}.state`,
          address?.value?.terms[3]?.value
        );
        formik.setFieldValue(
          `addressInfo.${idx}.city`,
          address?.value?.terms[2]?.value
        );
      }
    }
  };

  const addAddrsss = () => {
    setBooleanValue(true);

    const handleValidate = Object.entries(formik?.values?.addressInfo)
      .map((item) => {
        return item[1];
      })
      .every((item) => {
        const { active, city, state, zip_code } = item;
        return !!(city && state && zip_code);
      });
    if (handleValidate) {
      setAddressInfo((prev) => [
        ...formik.values.addressInfo,
        {
          // neighborhood: "",
          // country: "",
          active: false,
          billing: false,
          location: {},
          city: "",
          zip_code: null,
          state: "",
          addressLine2: "",
        },
      ]);
    } else {
      return toastr.info(
        "Validation",
        "please fill all mandatory address fields"
      );
    }
  };

  const handleMergeButton = () => {
    setIsOpenMergePopUp(!isOpenMergePopUp);
    formik.setFieldValue("account", {});
    formik.setFieldValue("error", false);
    setValue("");
  };
  const handleMergeApi = async () => {
    const token = await getAccessTokenSilently();
    const data = {
      accountId: formik.values.account?.accounts?._id,
      mergeToAccountId: account?._id,
    };
    if (token) {
      setLoadingMerge(true);
      await FinanceService.MergeAccount(data, token)
        .then((res) => {
          handleMergeButton();
          toastr.success("Success", "Merged Account successfully");
        })
        .catch((err) => {
          toastr.error("error", err?.data?.message || "Merged Account Failed");
        })
        .finally(() => {
          setLoadingMerge(false);
        });
    }
  };

  const removeAddress = (idx) => {
    setBooleanValue(true);
    const splicedAddressInfo =
      addressInfo.length > 0 ? [...addressInfo] : account?.addresses;
    splicedAddressInfo.splice(deletedId, 1);

    if (splicedAddressInfo.length > 0) {
      setAddressInfo(splicedAddressInfo);
    } else {
      setAddressInfo((prev) => [
        {
          active: false,
          billing: false,
          location: {},
          city: "",
          zip_code: null,
          state: "",
          addressLine2: "",
        },
      ]);
      formik.setFieldValue(`addressInfo.${idx}.zip_code`, "");
      formik.setFieldValue(`addressInfo.${idx}.neighborhood`, "");
      formik.setFieldValue(`addressInfo.${idx}.country`, "");
    }
    setOpen(false);
  };

  useEffect(() => {
    if (booleanValue === true) {
      formik.setValues({
        ...formik.values,
        addressInfo,
      });
      setBooleanValue(false);
    }
  }, [addressInfo]);

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40) e.preventDefault();
  };
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }

  const directoryCheckboxesList = [
    {
      id: "hideDirectory",
      label: "Hide on member directory",
      value: formik.values?.hideDirectory,
      onChange: (e) => {
        formik.setFieldValue("hideDirectory", e.target.checked);
      },
    },
    {
      id: "hideEmail",
      label: "Hide email address on member directory",
      value: formik.values?.hideEmail,
      onChange: (e) => {
        formik.setFieldValue("hideEmail", e.target.checked);
      },
    },
    {
      id: "hideMobile",
      label: "Hide mobile number on member directory",
      value: formik.values?.hideMobile,
      onChange: (e) => {
        formik.setFieldValue("hideMobile", e.target.checked);
      },
    },
    {
      id: "hideHomeNumber",
      label: "Hide home number on member directory",
      value: formik.values?.hideHomeNumber,
      onChange: (e) => {
        formik.setFieldValue("hideHomeNumber", e.target.checked);
      },
    },
    {
      id: "hideAddress",
      label: "Hide address on member directory",
      value: formik.values?.hideAddress,
      onChange: (e) => {
        formik.setFieldValue("hideAddress", e.target.checked);
      },
    },
  ];

  const checkCanCopyAddress = (item) => {
    const address = item?.location?.formattedAddress || "";
    const { addressLine2, city, state, zip_code } = item;
    const valid =
      address?.trim().length ||
      addressLine2?.trim().length ||
      city?.trim().length ||
      state?.trim().length ||
      zip_code?.trim().length;
    return valid;
  };
  const copyAddressHandler = (item) => {
    if (!checkCanCopyAddress(item)) return;
    const address = item?.location?.formattedAddress?.split(",")[0] || "";
    const { addressLine2 = "", city = "", state = "", zip_code = "" } = item;
    // const copyAddress = address + " " + (addressLine2 ? addressLine2 + " " : "") + city + (city && state ? ", " : "") + state + " " + zip_code;
    const copyAddress =
      address +
      (addressLine2 ? " " + addressLine2 : "") +
      (city ? ", " + city : "") +
      (city && state ? ", " : "") +
      state +
      " " +
      zip_code;

    navigator.clipboard.writeText(copyAddress);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  const closeModal = () => {
    setConfirmClose(true);
  };
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    handleMergeButton();
  };

  return (
    <>
      <div className="first-time w-100">
        {addressValue ? (
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <Loader />
          </div>
        ) : (
          <Card className="card card-custom pl-8 pr-15 mb-10">
            <div className="login-form login-signin">
              <form
                onSubmit={formik.handleSubmit}
                className="form fv-plugins-bootstrap fv-plugins-framework"
              >
                <div className="sub-title mt-10">
                  <Text style={styles.textIconButton}>Account Details</Text>
                  <hr />
                </div>
                <Row className="account-details-row">
                  <Col className="col-sm-3">
                    <InputField
                      {...{
                        formik,
                        disabled: false,
                        title: "Account name",
                        mandatory: true,
                        name: "family_admin_name",
                        checkValidation: true,
                        value: formik.values?.family_admin_name,
                      }}
                    />
                  </Col>
                  <Col className="col-sm-3">
                    <SelectField
                      {...{
                        formik,
                        title: "Account type",
                        name: "account_type",
                        mandatory: true,
                        items: ["Member", "Not a Member", "Organization"],
                        value: formik.values.account_type,
                        placeholder: "Select Account Type...",
                      }}
                      selectfieldColor={selectfieldColor}
                      onClick={(v) => {
                        formik.setFieldValue("account_type", v);
                        formik.setFieldValue("account_sub_type", {
                          id: "",
                          title: "",
                        });
                      }}
                    />
                  </Col>
                  <Col className="col-sm-3">
                    <div className="d-flex align-items-center">
                      <LabelField title={"Account Category"} />
                      <InfoTooltip text="A more specific classification within this account's Account Type, used for grouping in reports and segments." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                    </div>
                    <Select
                      {...{
                        formik,
                        title: "Category",
                        name: `account_sub_type`,
                        mandatory: false,
                        // checkValidation: false,
                      }}
                      isClearable={formik.values?.account_sub_type?.id ?? false}
                      onInputChange={(text) => searchAction(text)}
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={options2}
                      isLoading={loading}
                      styles={colourStyles}
                      onChange={(value) => {
                        if (!value) {
                          formik.setFieldValue("account_sub_type", {
                            id: "",
                            title: "",
                          });
                          return;
                        }
                        formik.setFieldValue(`account_sub_type`, {
                          id: value.value,
                          title: value.label,
                        });
                      }}
                      value={{
                        label: formik.values?.account_sub_type?.title,
                        value: formik.values?.account_sub_type?.id,
                      }}
                      components={{ DropdownIndicator }}
                    />
                  </Col>
                  <Col className="col-sm-3">
                    <LabelField title={"Billing type"} />

                    <Select
                      {...{
                        formik,
                        name: `billing_type`,
                        mandatory: false,
                        // checkValidation: false,
                      }}
                      isClearable={formik.values?.billing_type?.id ?? false}
                      onInputChange={(text) => searchAction(text)}
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={options}
                      isLoading={loading}
                      styles={colourStyles}
                      onChange={(value) => {
                        if (!value) {
                          formik.setFieldValue("billing_type", {
                            id: "",
                            title: "",
                          });
                          return;
                        }
                        formik.setFieldValue(`billing_type`, {
                          id: value.value,
                          title: value.label,
                        });
                      }}
                      value={{
                        label: formik.values?.billing_type?.title,
                        value: formik.values?.billing_type?.id,
                      }}
                      components={{ DropdownIndicator }}
                    />
                  </Col>
                </Row>
                <div className="sub-title">
                  <Text style={styles.textIconButton}>Other info</Text>
                  <hr />
                </div>
                <Row>
                  <Col className="col-sm-3">
                    <InputField
                      {...{
                        formik,
                        disabled: false,
                        title: "Mailing label name",
                        mandatory: true,
                        name: "mailLabelName",
                        checkValidation: true,
                        value: formik.values?.mailLabelName,
                      }}
                    />
                  </Col>
                  <Col className="col-sm-3">
                    <InputField
                      {...{
                        formik,
                        disabled: true,
                        mandatory: true,
                        title: "Account ID",
                        name: "account_id",
                        value: formik.values?.account_id,
                      }}
                    />
                    {formik.values?.account_id === "" && (
                      <p className="text-red my-2">Required!</p>
                    )}
                  </Col>
                  <Col className="col-sm-3">
                    <InputField
                      {...{
                        formik,
                        disabled: true,
                        mandatory: true,
                        title: "Number of family members",
                        name: "family_members",
                        value: formik.values?.family_members,
                      }}
                    />
                    {formik.values?.family_members === "" && (
                      <p className="text-red my-2">Required!</p>
                    )}
                  </Col>
                  <Col className="col-sm-3">
                    <InputField
                      {...{
                        formik,
                        // disabled: true,
                        title: "Family admin name",
                        name: "family_name",
                        // mandatory: true,
                        checkValidation: true,
                        value: formik?.values?.family_name,
                      }}
                    />
                  </Col>
                  <Col className="col-sm-3 mt-5">
                    <div className="d-flex align-items-center">
                      <LabelField title={"Family admin contact"} />
                      <InfoTooltip text="The main phone number used to reach this family/account, shown alongside the family admin name in reports and segments." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                    </div>
                    <PhonePicker
                      value={formik?.values?.family_admin_contact || ""}
                      handleChange={(e) => {
                        formik.setFieldValue("family_admin_contact", e);
                      }}
                      placeholder="Family admin contact"
                      copy={true}
                    />
                  </Col>
                  <Col className="col-sm-3 mt-5">
                    <InputField
                      {...{
                        formik,
                        // disabled: true,
                        title: "Old Account ID",
                        name: "old_account_id",
                        value: formik.values?.old_account_id || "",
                      }}
                      handleChange={(event) => {
                        formik.setFieldValue(
                          `old_account_id`,
                          event.target.value.match(regex)[0]
                        );
                      }}
                    />
                  </Col>
                  <Col className="col-sm-3 mt-5">
                    <div className="form-group">
                      <div className="d-flex align-items-center">
                        <LabelField title={"Join Date"} />
                        <InfoTooltip text="The date this account joined the organization. Used for tenure/anniversary reporting." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                      </div>
                      <DatePicker
                        isClearable
                        showIcon
                        placeholderText={placeholderFormat}
                        dateFormat={dateFormat}
                        selected={
                          formik.values?.join_date &&
                          convertUTCToLocalDate(formik.values?.join_date)
                        }
                        maxDate={new Date()}
                        onChange={(e) => {
                          setJoinDate(e);
                          formik.setFieldValue(`join_date`, e);
                          convertLocalToUTCDate(e, "join_date");
                        }}
                        showYearDropdown
                        customInput={
                          <MaskedInput
                            pipe={autoCorrectedDatePipe}
                            mask={dateMask}
                            keepCharPositions={true}
                            guide={true}
                          />
                        }
                      />
                    </div>
                  </Col>
                  <Col className="col-sm-3 mt-5">
                    <div className="resign_date">
                      <div className="d-flex align-items-center">
                        <LabelField title={"Resign Date"} />
                        <InfoTooltip text="The date this account left/resigned the organization." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                      </div>
                      <DatePicker
                        isClearable
                        showIcon
                        placeholderText={placeholderFormat}
                        dateFormat={dateFormat}
                        minDate={new Date(formik.values?.join_date)}
                        selected={
                          formik.values?.resign_date &&
                          // new Date(formik.values?.resign_date)
                          convertUTCToLocalDate(formik.values?.resign_date)
                        }
                        onChange={(e) => {
                          formik.setFieldValue(`resign_date`, e);
                          convertLocalToUTCDate(e, "resign_date");
                        }}
                        customInput={
                          <MaskedInput
                            pipe={autoCorrectedDatePipe}
                            mask={dateMask}
                            keepCharPositions={true}
                            guide={true}
                          />
                        }
                      />
                    </div>
                  </Col>
                </Row>

                <div className="sub-title mt-10">
                  <Text style={styles.textIconButton}>Addresses Info</Text>
                  <hr />
                </div>

                {formik?.values?.addressInfo?.map?.((item, idx) => (
                  <>
                    <div className="sub-title mb-2 d-flex align-items-center">
                      <Text style={styles.textIconButton}>
                        Address {idx + 1}
                      </Text>
                      {checkCanCopyAddress(item) && (
                        <div
                          className="ml-5 cursor-pointer position-relative"
                          onClick={() => {
                            copyAddressHandler(item);
                          }}
                        >
                          <CopyToClipboard text={value}>
                            <CopyIconGray />
                          </CopyToClipboard>
                          {isCopied && (
                            <div className="copy-value__hint copy-value__hint--address">
                              {"Copied"}
                            </div>
                          )}
                        </div>
                      )}

                      <MinusDelete
                        className="ml-5"
                        role="button"
                        onClick={() => {
                          setOpen(true);
                          SetDeletedId(idx);
                        }}
                      />
                      <div className="ml-7 d-flex align-items-center">
                        <MyCheckbox
                          {...{
                            formik,
                            title: "Apply to all contacts",
                            name: `applyAddressToContacts`,
                          }}
                          style={{ alignItems: "center" }}
                          handlechange={(event) => {
                            if (!event.target.checked) {
                              formik.setFieldValue(
                                `addressInfo.${idx}.applyAddressToContacts`,
                                event.target.checked
                              );
                              return;
                            }
                            setIndexApplyAllContactValue(idx);
                            setOpenAlert(true);
                          }}
                          checked={item?.applyAddressToContacts}
                        />
                        <InfoTooltip text="Copies this address to every contact on the account, instead of it only being set at the account level." style={{ marginLeft: '6px', transform: 'translateY(-2px)' }} />
                      </div>
                    </div>
                    <Row className="align-items-center">
                      <Col className="col-sm-3 ">
                        <FindMyCity
                          handleChange={(data) =>
                            addressHandleChange(data, idx)
                          }
                          title="Address"
                          value={
                            item?.location?.formattedAddress
                              ? {
                                  label: (item?.location.formattedAddress).split(",")[0],
                                  value: `${item?.location?.place_id}`,
                                }
                              : null
                          }
                          inputLike
                          copy={true}
                          saveNewAddress={true}
                        />
                      </Col>
                      <Col className="col-sm-3 ">
                        <InputField
                          {...{
                            formik,
                            title: "Address line 2 (Optional)",
                            name: `addressInfo.${idx}.addressLine2`,
                            placeholder: "Apt, suite, unit, floor, company",
                            value: item?.addressLine2 || "",
                            copy: true,
                          }}
                        />
                      </Col>
                      <Col className="col-sm-3">
                        <InputField
                          {...{
                            formik,
                            title: "City",
                            name: `addressInfo.${idx}.city`,
                            placeholder: "Enter City",
                            value: item?.city || "",
                            copy: true,
                          }}
                        />
                      </Col>
                      <Col className="col-sm-3">
                        <InputField
                          {...{
                            formik,
                            title: stateLabel(),
                            name: `addressInfo.${idx}.state`,
                            placeholder: "NY",
                            checkValidation: true,
                            value: item?.state || "",
                            copy: true,
                          }}
                        />
                      </Col>
                      <Col className="col-sm-3 mt-5">
                        <InputField
                          {...{
                            formik,
                            title: postalCodeLabel(),
                            name: `addressInfo.${idx}.zip_code`,
                            placeholder: postalCodeLabel(),
                            value: item?.zip_code || "",
                            copy: true,
                          }}
                          handleChange={(event) => {
                            formik.setFieldValue(
                              `addressInfo.${idx}.zip_code`,
                              event.target.value
                            );
                          }}
                          onKeyDown={(e) => preventArrows(e)}
                        />
                      </Col>
                      <Col className="col-sm-3 mt-5">
                        <InputField
                          {...{
                            formik,
                            title: "Neighborhood",
                            name: `addressInfo.${idx}.neighborhood`,
                            placeholder: "Neighborhood",
                            value: item?.neighborhood || "",
                            copy: true,
                          }}
                        />
                      </Col>
                      <Col className="col-sm-3 mt-5">
                        <InputField
                          {...{
                            formik,
                            title: "Country",
                            name: `addressInfo.${idx}.country`,
                            placeholder: "Enter Country",
                            value: item?.country || "",
                            copy: true,
                          }}
                        />
                      </Col>
                      <Col className="col-sm-1 mt-15">
                        <MyCheckbox
                          {...{
                            formik,
                            title: "Active",
                            name: `addressInfo.${idx}.active`,
                          }}
                          title="Active"
                          handlechange={(event) => {
                            setIndexValue(idx);
                            formik.setFieldValue(
                              `addressInfo.${idx}.active`,
                              event.target.checked
                            );
                          }}
                          checked={item?.active}
                        />
                      </Col>
                      <div className="mr-3 mt-15">
                        <MyCheckbox
                          {...{
                            formik,
                            title: "Billing",
                            name: `addressInfo.${idx}.billing`,
                          }}
                          title="Billing"
                          handlechange={(event) => {
                            setIndexBillingValue(idx);
                            formik.setFieldValue(
                              `addressInfo.${idx}.billing`,
                              event.target.checked
                            );
                          }}
                          checked={item?.billing}
                        />
                      </div>
                    </Row>
                    <Row></Row>
                    <AlertDialog
                      open={openDialog}
                      onDecline={() => {
                        setOpen(false);
                      }}
                      onAccept={() => {
                        removeAddress(idx);
                      }}
                      title={"Are you sure?"}
                      description={`Do you want to delete this address?`}
                    />
                    <hr />
                  </>
                ))}
                <div className="add-new-payment-info col my-4">
                  <span className="add-icon" onClick={addAddrsss}>
                    <AddIcon />
                  </span>
                  <span className="add" onClick={addAddrsss}>
                    Add Address
                  </span>
                </div>

                <div className="sub-title mt-10">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Text style={styles.textIconButton}>
                      Directory preferences
                    </Text>
                    <InfoTooltip text="Controls what this account/contact's information shows in the member portal directory that other members can browse." style={{ marginLeft: '6px', transform: 'translateY(1px)' }} />
                  </div>
                  <hr />
                </div>
                <CheckBoxesContainer>
                  {directoryCheckboxesList?.map((checkbox) => (
                    <CheckBox key={checkbox?.id}>
                      <label className="check-box-container">
                        <input
                          type="checkbox"
                          checked={checkbox?.value}
                          onChange={checkbox?.onChange}
                        />
                        <span className="checkbox-checkmark"></span>
                      </label>
                      <Label>{checkbox?.label}</Label>
                    </CheckBox>
                  ))}
                </CheckBoxesContainer>
                <div className="sub-title mt-10">
                  <hr />
                </div>
                <CheckBoxesContainer>
                  <CheckBox style={{ width: 'auto' }}>
                    <label className="check-box-container">
                      <input
                        type="checkbox"
                        checked={formik.values?.archived}
                        onChange={handleArchiveOnChange}
                      />
                      <span className="checkbox-checkmark"></span>
                    </label>
                    <Label>Archive Account</Label>
                    <InfoTooltip text="Marks this account as inactive/archived. You can filter accounts by their archived status in reports and segments." style={{ marginLeft: '6px', transform: 'translateY(-4px)' }} />
                  </CheckBox>
                </CheckBoxesContainer>
                <Buttons>
                  <Button
                    onClick={handleMergeButton}
                    variant="secondary-light"
                    className={`my-3 ml-3`}
                    size="md"
                    style={{ minWidth: "100px" }}
                  >
                    <MergeIcon />
                    <span>Merge</span>
                  </Button>
                  <div className="d-flex align-items-center justify-content-end flex-wrap mr-5">
                    <div className="form-group my-4">
                      <Button
                        onClick={() => history.push("/members")}
                        variant="primary-outline"
                        className={`my-3`}
                        size="md"
                        style={{ minWidth: "100px" }}
                      >
                        <span>Cancel</span>
                      </Button>
                    </div>
                    <div className="form-group my-4">
                      <Button
                        onClick={validateSubmit}
                        variant="primary"
                        className={`my-3 ml-5`}
                        size="md"
                        style={{ minWidth: "100px" }}
                      >
                        <span>Save</span>
                        {loading && (
                          <span className="ml-3 spinner spinner-white"></span>
                        )}
                      </Button>
                    </div>
                  </div>
                </Buttons>
              </form>
            </div>
          </Card>
        )}
      </div>
      <AlertDialog
        open={openAlert}
        onDecline={() => {
          setIndexApplyAllContactValue(null);
          setOpenAlert(false);
        }}
        onAccept={() => {
          handleApplyAddressToContactsChange(indexApplyAllContactValue);
          setOpenAlert(false);
        }}
        title={`Are you sure?`}
        description={"Do you want to apply this address to all contacts?"}
      />

      <AlertDialog
        open={isOpen}
        onDecline={() => {
          formik.setFieldValue("archived", account?.archived);
          setIsOpen(false);
        }}
        onAccept={handleConfirmArchiveAccount}
        title={"Are you sure?"}
        description={message}
      />

      {Object.keys(account).length > 0 && (
        <NewDialog
          isOpen={isOpenMergePopUp}
          message={message}
          handleClose={closeModal}
          loading={loadingMerge}
          title={"Merge Accounts"}
          sx={{
            "& .MuiDialog-paperWidthSm": {
              minWidth: "997.01px",
              height: "97%",
            },
          }}
          content={
            <ContentWrapper>
              <MergeAccountsDetails
                account={account}
                formik={formik}
                value={value}
                setValue={setValue}
              />
              <Wrapper>
                <Button
                  onClick={closeModal}
                  variant="primary-outline"
                  size="md"
                  style={{ minWidth: "100px" }}
                >
                  <span>Cancel</span>
                </Button>
                <Button
                  onClick={handleMergeApi}
                  variant="primary"
                  size="md"
                  style={{ minWidth: "100px" }}
                  disabled={
                    loadingMerge || !value.toLowerCase().includes("merge")
                  }
                >
                  {loadingMerge ? (
                    <BeatLoader color="#fff" size={6} margin={1} />
                  ) : (
                    <span>Merge</span>
                  )}
                </Button>
              </Wrapper>
            </ContentWrapper>
          }
          contentStyle={{
            display: "flex",
            justifyContent: "center",
            height: "100%",
          }}
          buttonStyle={{ justifyContent: "right" }}
        ></NewDialog>
      )}

      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
      <AlertDialog
        open={openDisableMemberUserModal}
        onDecline={() => {
          setOpenDisableMemberUserModal(false);
          updateAccountDetailsHandler();
        }}
        onAccept={() => {
          updateAccountDetailsHandler(true);
        }}
        title={"Are you sure?"}
        description={`Do you want to disable member’s portal access?`}
        disabled={loading}
      />
    </>
  );
};
export default AccountInfo;
